module.exports = __webpack_public_path__ + "img/IMG_9429.fd4ba9b0.jpg";